import { NgModule } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { ProductRoutingModule } from './product-routing.module';
import { ProductComponent } from './product/product.component';
import { TemplateModule } from '@project/shared/template/template.module';
import { ReviewsSharedModule } from '@project/shared/reviews-shared/reviews-shared.module';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';

import { StickyNavComponent } from '@components/sticky-nav/sticky-nav.component';
import { SafeHtmlPipe } from '@custom-pipes/safe-html/safe-html.pipe';
import { FaqComponent } from '@components/faq/faq.component';
import { InstallAppDialogComponent } from '@components/dialog/install-app-dialog/install-app-dialog.component';
import { DialogWorldwideComponent } from '@components/dialog/worldwide-dialog/worldwide-dialog.component';
import { ProductPageModule } from '@shared/product-page/product-page.module';
import { PaymentSystemsComponent } from '@components/payment-systems/payment-systems.component';


@NgModule({
  declarations: [
    ProductComponent,
  ],
  imports: [
    TemplateModule,
    ProductRoutingModule,
    TemplateModule,
    ReviewsSharedModule,
    ShareButtonsModule,
    ShareIconsModule,
    NgOptimizedImage,
    StickyNavComponent,
    InstallAppDialogComponent,
    DialogWorldwideComponent,
    SafeHtmlPipe,
    FaqComponent,
    ProductPageModule,
    PaymentSystemsComponent
  ]
})
export class ProductModule { }
